import { wait, noop } from '@/modules/utils';
import ScanProcess from '@/modules/scan-process';
import autoClearTimer from '@/mixins/auto-clear-timer';
import handleArmDetection from '@/mixins/arm-detection';
import leave from '@/mixins/leave';

const scanBody = {
  mixins: [autoClearTimer, handleArmDetection, leave],
  data: () => ({
    state: 0,
    countdownTimer: 0,
    info: '',
    scanProgress: -1,
    scanCompleted: false,
    showIntro: true,
    showClenchHint: false,
    error: false,
    stepTwo: false,
  }),
  methods: {
    async countdown(timer) {
      this.countdownTimer = timer;
      await wait(1.3);
      this.countdownTimer -= 1;
      if (this.countdownTimer) {
        await this.countdown(this.countdownTimer);
      }
    },
    startProgress(to, quicker) {
      if (this.scanProgress >= to) return;

      const timeout = quicker ? 30 : 50;
      const increase = () => {
        if (this.scanProgress < to) {
          this.scanProgress += 1;
          setTimeout(increase, timeout);
        }
      };
      increase();
    },
    resetProgress() {
      this.scanProgress = -1;
    },
    setScanComplete() {
      this.left = 0;
      this.right = 0;
      this.scanCompleted = true;
      this.info = this.$t('scan.scan_complete');
    },
    async startScan(force) {
      if ((!this.bothHit || this.state) && !force) return;

      this.state = 1;
      this.stopListen();
      this.stopArmDetection(null, true);
      this.putArmsInRange();
      await Promise.all([
        ScanProcess.start(this.stepTwo).then(noop),
        this.countdown(3).then(() => this.startProgress(99, false)),
      ]);
      await ScanProcess.waitScan(this.stepTwo);
      console.log('wait scan finished');
      this.startProgress(100, true);
      await this.waitForComplete();
      this.setScanComplete();
      this.resetProgress();
    },
    async waitForComplete() {
      await wait(0.5);
    },
    showError(message) {
      this.error = true;
      if (message) {
        this.info = message;
      }
    },
    async finish() {
      if (this.twoStepScan && !this.stepTwo) {
        this.info = this.$t('scan.phase_one_done');
        await this.playAndWait('phase_one_complete', 1);
        this.info = this.$t('scan.begin_2nd');
        await this.playAndWait('proceeding_phase_two', 1.5);
        this.stepTwo = true;
      } else {
        this.$events.goto('Analyzing');
      }
    },
  },
  computed: {
    twoStepScan() {
      return ScanProcess.twoStepScan();
    },
    bothReady() {
      return this.leftReady && this.rightReady;
    },
    scanInProgress() {
      return this.scanProgress > -1;
    },
  },
};

export default scanBody;
